import { render } from "./PolicyReview.vue?vue&type=template&id=c66c586c&scoped=true"
import script from "./PolicyReview.vue?vue&type=script&lang=js"
export * from "./PolicyReview.vue?vue&type=script&lang=js"

import "./PolicyReview.vue?vue&type=style&index=0&id=c66c586c&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c66c586c"]])

export default __exports__